module.exports = __webpack_public_path__ + "img/logo-interval.ddd33c51.svg";